import { Check } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import { IMAGES, FEATURES } from "@/lib/site";

export default function Survey() {
  return (
    <>
      <Seo
        title="Free Site Survey — Check Availability | CYAN Wireless"
        description="Check if CYAN Wireless is available at your address and request a free site survey. Fast, reliable rural internet in Cortez, Dolores, Yellow Jacket & Lewis, Colorado — no contracts, unlimited data."
        path="/survey"
      />
      <section className="relative pt-40 pb-24 sm:pt-48 bg-ink-950 overflow-hidden min-h-screen">
        <div className="absolute inset-0 z-0">
          <img src={IMAGES.mesaPink} alt="" className="w-full h-full object-cover opacity-15" />
          <div className="absolute inset-0 bg-gradient-to-b from-ink-950/80 to-ink-950" />
        </div>
        <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-start">
          <Reveal>
            <p className="overline mb-6 flex items-center gap-3"><span className="w-8 h-px bg-cyan-500" />Free Site Survey</p>
            <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-white leading-[0.9]">
              Let's get you<br /><span className="text-cyan-400 text-glow">connected.</span>
            </h1>
            <p className="mt-6 text-lg text-zinc-400 max-w-md">
              Enter your address and we'll check availability, recommend the ideal wireless or WAVFiber plan, and schedule your free site survey — no obligation.
            </p>
            <ul className="mt-8 space-y-3">
              {FEATURES.slice(0, 4).map((f) => (
                <li key={f.title} className="flex items-center gap-3 text-white">
                  <span className="w-6 h-6 grid place-items-center rounded-full bg-cyan-500/15 text-cyan-400"><Check size={14} /></span>
                  {f.title}
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.1} className="bg-ink-900/90 backdrop-blur border border-white/10 rounded-2xl p-8">
            <h2 className="font-display font-bold text-2xl text-white mb-2">Check availability</h2>
            <p className="text-zinc-400 text-sm mb-6">Takes under a minute.</p>
            <LeadForm type="site_survey" submitLabel="Request My Free Survey" showAddress />
          </Reveal>
        </div>
      </section>
    </>
  );
}
